import { render } from "./HoursSubmitted.vue?vue&type=template&id=2513c32e&scoped=true"
import script from "./HoursSubmitted.vue?vue&type=script&lang=js"
export * from "./HoursSubmitted.vue?vue&type=script&lang=js"

import "./HoursSubmitted.vue?vue&type=style&index=0&id=2513c32e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2513c32e"]])

export default __exports__